import { useApi } from '@gravitate-js/the-armory'
import { useQuery } from '@tanstack/react-query'
import { getAPIURL } from '@utils/api'

export const useModelHistory = () => {
  const api = useApi({ baseURLOverride: getAPIURL() })

  const useModelHistoryQuery = () =>
    useQuery({ queryKey: ['modelHistoryOverviewQuery'], queryFn: () => api.post('solver/overview', {}) })

  return { useModelHistoryQuery }
}
